import { radar } from '../log';
import { touchEvent, TOUCH_EVENT_NAMES } from './withGlobalTouch';

// 低于 24 算卡顿: https://nowjava.com/article/31452
const LAGGY_FPS_VALUE = 24;
const LAGGY_TIMES = 3;

const RecordsCache: Record<string, RecordFPS> = {};
class RecordFPS {
    // 整体帧率
    allFrameCount: number;
    startTime: number;

    // 每秒帧率
    persecFrameCount: number;
    persecTime: number;

    requestFrameId: number | null;
    // 是否已结束
    isEnd: boolean;

    // 避免重复记录
    name: string;

    // valid
    isTouched: boolean;
    isFMP: boolean;
    isLaggyTimes: number;
    touchStartTime: number;
    touchEndTime: number;
    fmpStartTime: number;

    constructor(name: string) {
        this.name = name;
        this._reset();
        touchEvent.addListener(TOUCH_EVENT_NAMES.VIEW_TOUCH_START, ({ time }) => {
            this.touchStartTime = time;
            if (!this.isTouched) {
                this.isTouched = true;
                this._checkAndStartLoop();
            }
        });
        touchEvent.addListener(TOUCH_EVENT_NAMES.VIEW_TOUCH_END, ({ time }) => {
            this.touchEndTime = time;
        });
        touchEvent.addListener(TOUCH_EVENT_NAMES.VIEW_REMOVE_LOOP, () => {
            this.isEnd = true;
            this._reset();
        });
    }

    _reset = (time?: number) => {
        this.allFrameCount = 0;
        this.startTime = time || 0;
        if (this.requestFrameId) {
            cancelAnimationFrame(this.requestFrameId);
            this.requestFrameId = null;
        }
        this.isLaggyTimes = 0;
        this.isTouched = false;
        this._resetPersec(this.startTime);
    };

    _resetPersec = (time?: number) => {
        this.persecFrameCount = 0;
        this.persecTime = time || 0;
    };

    // report 相关
    _checkIfReadyToReport = () => {
        return this.isLaggyTimes >= LAGGY_TIMES;
    };
    _reportFPSBadCase = (fps: number) => {
        this.isEnd = true;
        const curTime = Date.now();

        const params: {
            fps: number;
            fmpDuration?: number;
            touchStartDuration?: number;
            touchEndDuration?: number;
        } = {
            fps, // 最近一次低于阈值的 FPS
        };
        if (this.fmpStartTime) {
            params.fmpDuration = curTime - this.fmpStartTime; // 卡顿发生时距离 FMP 上报的时间
        }
        if (this.touchStartTime) {
            params.touchStartDuration = curTime - this.touchStartTime; // 卡顿发生时距离最近一次手指触摸开始时的时间
        }
        if (this.touchEndTime) {
            params.touchEndDuration = curTime - this.touchEndTime; // 卡顿发生时距离最近一次手指触摸结束时的时间
        }
        radar.event({
            name: 'SHOP_KRN_FPS_BADCASE',
            params,
        });
    };

    // start 相关
    _checkIfReadyToStart = () => {
        return this.isFMP && this.isTouched;
    };
    _checkAndStartLoop = () => {
        if (this._checkIfReadyToStart()) {
            this._loop();
        }
    };
    _loop = () => {
        if (this.isEnd) {
            return null;
        }
        this.allFrameCount++;
        this.persecFrameCount++;

        const curTime = Date.now();

        if (!this.persecTime) {
            this.persecTime = curTime;
        }
        if (!this.startTime) {
            this.startTime = curTime;
        }

        const duration = curTime - this.persecTime;
        if (duration >= 1000) {
            const fps = Math.round((this.persecFrameCount * 1000) / duration);
            if (fps <= LAGGY_FPS_VALUE) {
                this.isLaggyTimes++;
                // 连续两次低于阈值，才会考虑上报
                if (this._checkIfReadyToReport()) {
                    this._reset();
                    return this._reportFPSBadCase(fps);
                }
            } else {
                this.isLaggyTimes = 0;
            }
            this._resetPersec(curTime);
        }

        this.requestFrameId = requestAnimationFrame(() => {
            this._loop();
        });
    };

    startRecordWithFMP = () => {
        if (this.isEnd) {
            return null;
        }
        this.isFMP = true;
        this.fmpStartTime = Date.now();
        this._checkAndStartLoop();
    };
}

// 以类似 JS Error 的方式监听 JS 帧率
// 超过 1s 的平均小于 30 就上报异常
export default (name: string): RecordFPS => {
    if (RecordsCache[name]) {
        return RecordsCache[name];
    }
    const record = new RecordFPS(name);
    RecordsCache[name] = record;
    return record;
};
